// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoginForm {
  /* width: 30%; */
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  margin-right: 0.625rem;
}
.LoginForm p {
  color: white;
}
.LoginForm input {
  border: none;
  width: 25rem;
  padding: 0.625rem;
  color: white;
  font-size: 0.938rem;
  background: none;
  border: none;
  outline: none;
}
.LoginForm input:focus {
  background: none;
  border: none;
  outline: none;
}
.LoginForm .input_container {
  display: flex;
  border-bottom: 0.063rem solid white;
  align-items: center;
}
.LoginForm .hanker {
  padding: 0.625rem;
  border: none;
  border-radius: 0.625rem;
  background-color: #8b1c6b;
  width: 30%;
  cursor: pointer;
}
.LoginForm .login {
  padding: 0.625rem;
  border: none;
  border-radius: 1.875rem;
  background-color: #06bea7;
  width: 100%;
  cursor: pointer;
}
.LoginForm .btn_container {
  display: flex;
  flex-direction: column;
  color: white;
  justify-content: center;
  align-items: center;
  gap: 1.25rem;
}
`, "",{"version":3,"sources":["webpack://./src/styles/components/LoginForm.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;AACf;AACA;EACE,aAAa;EACb,mCAAmC;EACnC,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;EACzB,UAAU;EACV,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd","sourcesContent":[".LoginForm {\n  /* width: 30%; */\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n  margin-right: 0.625rem;\n}\n.LoginForm p {\n  color: white;\n}\n.LoginForm input {\n  border: none;\n  width: 25rem;\n  padding: 0.625rem;\n  color: white;\n  font-size: 0.938rem;\n  background: none;\n  border: none;\n  outline: none;\n}\n.LoginForm input:focus {\n  background: none;\n  border: none;\n  outline: none;\n}\n.LoginForm .input_container {\n  display: flex;\n  border-bottom: 0.063rem solid white;\n  align-items: center;\n}\n.LoginForm .hanker {\n  padding: 0.625rem;\n  border: none;\n  border-radius: 0.625rem;\n  background-color: #8b1c6b;\n  width: 30%;\n  cursor: pointer;\n}\n.LoginForm .login {\n  padding: 0.625rem;\n  border: none;\n  border-radius: 1.875rem;\n  background-color: #06bea7;\n  width: 100%;\n  cursor: pointer;\n}\n.LoginForm .btn_container {\n  display: flex;\n  flex-direction: column;\n  color: white;\n  justify-content: center;\n  align-items: center;\n  gap: 1.25rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
